import { render, staticRenderFns } from "./BeneficiaryFixedBenefits.vue?vue&type=template&id=ced51860&scoped=true"
import script from "./fixed_benefits.js?vue&type=script&lang=js&external"
export * from "./fixed_benefits.js?vue&type=script&lang=js&external"
import style0 from "./BeneficiaryFixedBenefits.vue?vue&type=style&index=0&id=ced51860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced51860",
  null
  
)

export default component.exports